import {
  CarrierIntegration,
  CarrierIntegrationState,
} from "./carrier-integration.model";

export class CarrierIntegrationMapper {
  public static map(
    data: Partial<CarrierIntegrationState> | null | undefined,
  ): CarrierIntegration {
    return new CarrierIntegration(CarrierIntegrationMapper.mapState(data));
  }

  public static mapState(
    data: Partial<CarrierIntegrationState> | null | undefined,
  ): CarrierIntegrationState {
    const account = data?.account;

    return {
      connected: data?.connected === true,
      expiresAt: data?.expiresAt ?? null,
      revokedAt: data?.revokedAt ?? null,
      reconnectRetryAt: data?.reconnectRetryAt ?? null,
      automatedConnectAvailable: data?.automatedConnectAvailable === true,
      account: {
        set: account?.set === true,
        login: account?.login ?? null,
        providedAt: account?.providedAt ?? null,
        revealedAt: account?.revealedAt ?? null,
        revealedByName: account?.revealedByName ?? null,
      },
    };
  }
}
